import { type FC } from 'react';

import { AgentsDirectoryCard } from './agents-directory-card';
import { type DirectoryAgent } from './filter-agents';

interface AgentsDirectoryGridProps {
  agents: DirectoryAgent[];
  /** `trigger` is the card's button, where focus returns when the details close. */
  onOpen: (agent: DirectoryAgent, trigger: HTMLElement) => void;
}

/**
 * The directory's grid. Its own rather than `layouts/card-grid.tsx`, which
 * counts columns off viewport breakpoints: the side nav collapses without the
 * viewport changing, so that grid would keep its column count and squash the
 * cards.
 *
 * 254 is measured off the frame. It does not quite fill the shell's column —
 * 4 × 254 + 3 × 16 = 1064 against 1136 — so the tracks take the slack and cards
 * render about 272 wide. Accepted with design rather than pinning the width and
 * leaving a 72px gutter.
 *
 * `min(254px, 100%)` and not a bare 254px: minmax floors the track at its
 * minimum even as the only track, so a narrower container would scroll sideways
 * instead of reflowing.
 */
export const AgentsDirectoryGrid: FC<AgentsDirectoryGridProps> = ({ agents, onOpen }) => (
  <div className="grid gap-4 [grid-template-columns:repeat(auto-fill,minmax(min(254px,100%),1fr))]">
    {agents.map((agent) => (
      <AgentsDirectoryCard agent={agent} key={agent.serviceName} onOpen={onOpen} />
    ))}
  </div>
);
